import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import Input from "components/Elements/Input";
import Checkbox from "components/Elements/Checkbox";
// import Select from "components/Elements/Select";
import Select from "react-select";
import { saveMedia, clearSavedMedia } from "actions/agents";
import { getTrainingWorkflows } from "actions/workflows";
import styled from "styled-components";

export const ErrorField = styled.span`
  color: red;
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

const AddMediaModal = NiceModal.create(
  ({ agent_id, onSaveMedia = () => {}, onError = () => {} }) => {
    const dispatch = useDispatch();
    const { savingMedia } = useSelector((state) => state.agents);
    const { trainingWorkflows } = useSelector((state) => state.workflows);
    const modal = useModal();
    const mediaTypes = ["file", "text", "url"];
    const frequencyTypes = ["hourly", "daily", "weekly", "monthly"];
    const formRef = useRef(null);
    const [media, setMedia] = useState({});
    const [selectedTrainingWorkflow, setSelectedTrainingWorkflow] = useState(
      null
    );
    const [trainingWorkflowOptions, setTrainingWorkflowOptions] = useState([]);

    console.log("!!! TRAINING WORKFLOWS: ", trainingWorkflows);

    useEffect(() => {
      if (trainingWorkflows) {
        console.log(
          "TRAINING WORKFlOW OPTIONS: ",
          trainingWorkflows.map((w) => {
            return { value: w.public_id, label: w.name };
          })
        );
        setTrainingWorkflowOptions(
          trainingWorkflows.map((w) => {
            return { value: w.public_id, label: w.name };
          })
        );
      } else {
        dispatch(getTrainingWorkflows());
      }
      // eslint-disable-next-line
    }, [trainingWorkflows]);

    const hide = (e) => {
      if (e) {
        e.stopPropagation();
      }
      dispatch(clearSavedMedia());
      modal.remove();
    };

    const [formErrors, setFormErrors] = useState({});
    const handleChange = ({ target }) => {
      console.log("TARGET: ", target);
      const u = { ...media };

      if (target.type === "checkbox") {
        u[target.name] = target.checked;
      } else {
        u[target.name] = target.value;
      }
      setMedia(u);
    };

    const handleFileChange = (e) => {
      console.log("FILE UPLOAD: ", e);
    };

    const handleMediaTypeChange = (mediaType) => {
      const m = { ...media };
      m.media_type = mediaType.value;
      setMedia(m);
    };

    const handleTrainingWorkflowChange = (trainingWorkflow) => {
      const m = { ...media };
      m.training_workflow_id = trainingWorkflow.value;
      m.training_workflow = trainingWorkflows.find(
        (w) => w.id === trainingWorkflow.value
      );
      setMedia(m);
      setSelectedTrainingWorkflow(trainingWorkflow);
    };

    const handleFrequencyTypeChange = (frequencyType) => {
      const m = { ...media };
      m.frequency_type = frequencyType;
      setMedia(m);
    };

    const validateFields = () => {
      setFormErrors({});
      const errors = {};

      console.log("media: ", media);
      const urlValid = !media.url || media.url.match(/^http(s):\/\/.*$/);
      errors.url = urlValid ? "" : " is invalid";
      const nameValid = media.name && media.name.length > 0;

      console.log("errors: ", errors);
      setFormErrors(errors);

      return nameValid;
    };

    const save = () => {
      console.log("save media: ", media);
      if (validateFields()) {
        dispatch(
          saveMedia(
            formRef.current,
            agent_id,
            (m) => {
              setMedia(m);
              onSaveMedia(m);
              console.log("media saved: ", media);
              hide();
            },
            (error) => {
              onError(error);
              console.log("error saving media: ", error);
            }
          )
        );
      }
    };

    const displayMediaTypeFields = () => {
      switch (media.media_type) {
        case "file":
          return (
            <>
              <input type="file" name="file" onChange={handleFileChange} />
            </>
          );
        case "text":
          return (
            <>
              <label>
                Text <ErrorField>{formErrors.text}</ErrorField>
              </label>
              <Input
                type="textarea"
                label="Text"
                placeholder="Text"
                name="text"
                value={media.text ?? ""}
                onChange={handleChange}
              />
            </>
          );
        case "url":
          return (
            <>
              <label>
                URL <ErrorField>{formErrors.url}</ErrorField>
              </label>
              <Input
                label="URL"
                placeholder="URL"
                name="url"
                value={media.url ?? ""}
                onChange={handleChange}
              />
              <Checkbox
                label="Follow Links"
                placeholder="followlinks"
                name="followlinks"
                value={media.followlinks ?? ""}
                onChange={handleChange}
              />
              {media.followlinks && (
                <Input
                  label="Link Pattern"
                  placeholder="Link Pattern"
                  name="linkpattern"
                  value={media.linkpattern ?? ""}
                  onChange={handleChange}
                />
              )}
              <Checkbox
                label="Schedule"
                placeholder="schedule"
                name="schedule"
                value={media.schedule ?? ""}
                onChange={handleChange}
              />
              {media.schedule && (
                <Select
                  label="Frequency"
                  placeholder="Frequency"
                  name="frequency"
                  defaultValue={media.frequency ?? ""}
                  items={frequencyTypes}
                  onChange={handleFrequencyTypeChange}
                />
              )}
              {media.followlinks}
            </>
          );
        default:
          return <></>;
      }
    };

    return (
      <>
        <div className="w-9/12 h-auto force-height-90 force-center items-center flex overflow-x-hidden overflow-y-hidden overflow-hidden fixed inset-0 z-50 outline-none focus:outline-none">
          <div className="relative w-full my-6 mx-auto max-w-3xl">
            {/*content*/}
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
              {/*header*/}
              <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                <h3 className="text-3xl font-semibold">
                  {media.id ? "Edit Media" : "Add Media"}
                </h3>
                <button
                  className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                  onClick={hide}
                >
                  <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                    ×
                  </span>
                </button>
              </div>
              {/*body*/}
              <div className="relative p-6 flex-auto ">
                <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                  <form ref={formRef}>
                    <label>
                      Name <ErrorField>{formErrors.name}</ErrorField>
                    </label>
                    <Input
                      label="Name"
                      placeholder="Name"
                      name="name"
                      value={media.name ?? ""}
                      onChange={handleChange}
                    />
                    <label>
                      Description{" "}
                      <ErrorField>{formErrors.description}</ErrorField>
                    </label>
                    <Input
                      type="textarea"
                      label="Description"
                      placeholder="Description"
                      name="description"
                      value={media.description ?? ""}
                      onChange={handleChange}
                    />
                    <div>
                      <Checkbox
                        label="Anonymize"
                        placeholder="anonymize"
                        name="anonymize"
                        value={media.anonymize ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                    <label>
                      Training Workflow{" "}
                      <ErrorField>{formErrors.training_workflow}</ErrorField>
                    </label>
                    <Select
                      label="Training Workflow"
                      placeholder="Choose a Training Workflow"
                      name="training_workflow"
                      value={selectedTrainingWorkflow}
                      options={trainingWorkflowOptions}
                      onChange={handleTrainingWorkflowChange}
                    />
                    <label>
                      Media Type <ErrorField>{formErrors.mediaType}</ErrorField>
                    </label>
                    <Select
                      label="Media Type"
                      placeholder="Media Type"
                      name="media_type"
                      value={
                        media.media_type
                          ? { label: media.media_type, value: media.media_type }
                          : null
                      }
                      options={mediaTypes.map((m) => {
                        return { value: m, label: m };
                      })}
                      onChange={handleMediaTypeChange}
                    />

                    {displayMediaTypeFields()}
                  </form>
                </div>
              </div>
              <div className="relative p-6 flex-auto"></div>
              {/*footer*/}
              <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                {!savingMedia ? (
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={hide}
                  >
                    Close
                  </button>
                ) : null}
                <button
                  className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={save}
                  disabled={savingMedia}
                >
                  {savingMedia ? (
                    <>
                      <i className="fas fa-circle-notch fa-spin"></i>{" "}
                      Processing...
                    </>
                  ) : (
                    <>Upload</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </>
    );
  }
);

export default AddMediaModal;
